var lib_core = require("lib-core");

/**
 * @constructor
 */
var RotateStateMachine = function (root, model) {
    var self = this;
    this.root = root;
    this.model = model;

    lib_core.StateMachine.call(this);

    var selectionModel = this.model.parent();

    this.addEventAction("idle",
        function(cEvent){
            return ((cEvent.type() == lib_core.GuiEvents.ROTATE_BUTTON
                        || cEvent.isKeyPressed( 'r', 'S_r')) &&
                    selectionModel.selection.size() > 0);
        },
        function(cEvent){
            var alreadyRecording = self.root.isRecording(); // TODO: not a good solution! this rotateSM shouldn't be merged in each and every state, placingSM should include this without the rec - stoprec itself!
            if (!alreadyRecording) self.root.rec();
            var direction = ( cEvent.data('shiftKey') ) ? -1 : 1;
            self.model.rotateSelection(direction);
            if (!alreadyRecording) self.root.stopRec();
        }, "Rotate selection"
    );
};
lib_core.inherit(RotateStateMachine, lib_core.StateMachine);

module.exports = RotateStateMachine;
